import type { Locale } from "../types";

/** 各语言在切换器上的短标签 */
const LABELS: Record<Locale, string> = { zh: "中", en: "EN" };

export function renderLangSwitch(current: Locale, locales: Locale[]): string {
  const buttons = locales
    .map(
      (l) =>
        `<button type="button" class="lang-btn${l === current ? " active" : ""}" data-locale="${l}" aria-pressed="${l === current}">${LABELS[l] ?? l}</button>`,
    )
    .join("");
  return `<div class="lang-switch" role="group" aria-label="Language">${buttons}</div>`;
}
